let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jScBC")).then(() => parcelRequire('1AVf4'));